/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemFormsUpdate } from '../../models/system-forms-update';

export interface UpdateSystemFormsInternalV2SystemFormsFormIdPatch$Params {
  formId: string;
  org: string;
      body: SystemFormsUpdate
}

export function updateSystemFormsInternalV2SystemFormsFormIdPatch(http: HttpClient, rootUrl: string, params: UpdateSystemFormsInternalV2SystemFormsFormIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFormsUpdate>> {
  const rb = new RequestBuilder(rootUrl, updateSystemFormsInternalV2SystemFormsFormIdPatch.PATH, 'patch');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemFormsUpdate>;
    })
  );
}

updateSystemFormsInternalV2SystemFormsFormIdPatch.PATH = '/_internal/v2/system-forms/{formId}';
